<template>
  <div id="footer" class="container-fluid">
    <div class = "footer-content">
		<div class = "content-1">
			<div class = "content-title">信尚安</div>
			<div class = "content-desc">备案号码：粤ICP备16079516号</div>
			<div class = "content-desc">粤公网安备 44010402002076号</div>
			<div class = "content-desc">地址：广州市海珠区沥滘路298号广航大厦</div>
		</div>
		<div class = "content-1">
			<div class = "content-title">联系我们</div>
			<div class = "content-desc">电话：400-902-0180/400-892-0805</div>
			<div class = "content-desc">邮箱：info@xinsec.com.cn</div>
			<div class = "content-desc">Q Q：3608371061</div>
		</div>
		<div class = "content-2">
			<div class = "content-qrc">
				<img src = "@/assets/img/qrcode_1.png"/>
			</div>
			<div class = "content-qrc-tips">
				信尚安信息
			</div>
		</div>
		<div class = "content-2">
			<div class = "content-qrc">
				<img src = "@/assets/img/qrcode_2.png"/>
			</div>
			<div class = "content-qrc-tips">
				信尚安物联
			</div>
		</div>
	</div>
    <p class="copy">Copyright &copy; 2018 - 2021 广州市信尚安信息技术有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(43, 48, 59, 1);
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: rgba(255, 255, 255, 0.65);
  font-size: 14px;
  margin: 50px 0 10px;
  font-weight: 400;
}

#footer .footer-content{
	display: flex;
  	flex-direction: row;
	justify-content:center;
	padding: 50px 0 0 0;
}

#footer .footer-content .content-1{
	text-align: left;
	margin: 0 50px 0 0;
	width: 264px;
}

#footer .footer-content .content-1 .content-title{
	font-size: 20px;
	padding: 0 0 16px 0;
}
#footer .footer-content .content-1 .content-desc{
	font-size: 14px;
	color:rgba(255, 255, 255, 0.5);
	font-weight:400;
}

#footer .footer-content .content-2{
	margin: 0 50px 0 0;
}
#footer .footer-content .content-2 .content-qrc{
	width: 120px;
	height: 120px;
}
#footer .footer-content .content-2 .content-qrc img{
	width: 100%;
	height: 100%;
}
#footer .footer-content .content-2 .content-qrc-tips{
	padding: 10px 0;
	font-size: 14px;
	color:rgba(255, 255, 255, 0.5)
}

@media screen and (max-width: 768px) {
	.title {
		font-size: 20px;
	}
	.address_tel_fax {
		font-size: 12px;
	}
	.email_wx {
		font-size: 12px;
	}
	.copy {
		font-size: 12px;
		margin: 30px 0 10px;
	}
	#footer .footer-content{
		display: flex;
		flex-direction: column;
		justify-content:center;
		padding: 20px 0 0 0;
	}

	#footer .footer-content .content-1{
		text-align: left;
		margin: 0 0px 20px 0;
		width: 100%;
		text-align: center;
	}

	#footer .footer-content .content-1 .content-title{
		font-size: 20px;
	}
	#footer .footer-content .content-1 .content-desc{
		font-size: 14px;
		color:rgba(255, 255, 255, 0.5)
	}

	#footer .footer-content .content-2{
		margin: 0 0px 0 0;
	}
	#footer .footer-content .content-2 .content-qrc{
		width: 120px;
		height: 120px;
		margin: 0 auto;
	}
	#footer .footer-content .content-2 .content-qrc img{
		width: 100%;
		height: 100%;
	}
	#footer .footer-content .content-2 .content-qrc-tips{
		padding: 10px 0;
		font-size: 14px;
		color:rgba(255, 255, 255, 0.5)
	}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue